export default "__VITE_ASSET__DX4Sh4PP__"